import { memo } from "react";
import { OrganizationBase } from "../types";
import "./organization-select-option.scss";

const OrganizationSelectOption = memo(
  ({ value }: { value: OrganizationBase }) => (
    // className контейнера находится выше (options className)
    <>
      <span className="organization-select-option-title">
        {value.shortName}
      </span>
      <br />
      <span className="organization-select-option-subtitle">{`ИНН: ${value.inn}, КПП: ${value.kpp}, ОГРН: ${value.ogrn}`}</span>
    </>
  ),
);

export default OrganizationSelectOption;
